export default __webpack_public_path__ + "static/media/discord_logo.65910271.svg";